// This is used to handle special cases for search queries.
type CustomACFFilterCheckbox = {
	[filterName: string]: {
		[checkboxValue: string]: any;
	};
};
const customACFFilterCheckboxes = {
	amplifier_gain: {
		'passive-only': {
			relation: 'AND',
			0: {
				key: 'gain',
				compare: '=',
				value: '',
			},
		},
	},
};

const middleware = (args: any) => {
	// This process is a bit of a hack to get the search to work with the products only search.
	// Typically the taxonomies are spread out in the args object, but for products only search, they are all in the tax_query object.
	// That way we can separate tax_query and meta_query effectively to parse data for the search.
	// We scan through the args and "pop" the ones we want to keep on the outside. Then the rest we assume are taxonomies.

	const searchArgs = { ...args };

	let staticArgs = {};
	let acfArgs = [];
	for (const key in searchArgs) {
		if (
			![
				'page',
				'search',
				'posts_per_page',
				'post_type',
				'business_unit',
				'all_search_list',
				'page',
				'meta_query',
				'card_type',
			].includes(key)
		) {
			// Check for ACF fields
			const searchArg = searchArgs[key];

			// console.log('---- Search arg', key, searchArg);

			// Handle custom ACF filter checkboxes
			const customACFFilterCheckbox = customACFFilterCheckboxes[key];
			if(customACFFilterCheckbox && Object.keys(customACFFilterCheckbox).some((checkboxValue) => searchArg.includes(checkboxValue))) {
				const checkboxValue = Object.keys(customACFFilterCheckbox).find((checkboxValue) => searchArg.includes(checkboxValue));
				const acfFilter = customACFFilterCheckbox[checkboxValue];
				acfArgs.push(acfFilter);
				delete searchArgs[key];
				continue;
			}

			if (
				Array.isArray(searchArg) &&
				searchArg.some((item: any) => item.startsWith('minimum-'))
			) {
				const min = searchArg.find((item) =>
					item.startsWith('minimum-'),
				);
				const max = searchArg.find((item) =>
					item.startsWith('maximum-'),
				);

				const argName = min.split('__')[0].split('-')[1];

				let minVal = 0;
				let maxVal = 100000; // Default to a very large number

				if (min) {
					minVal = parseInt(min.split('__')[1]);
				}

				if (max) {
					maxVal = parseInt(max.split('__')[1]);
				}

				if(argName == 'weight') {
					acfArgs.push({
						relation: 'AND',
						0: {
							key: argName,
							compare: 'BETWEEN',
							type: 'NUMERIC',
							value: [minVal, maxVal],
						},
					});
				} else { // we are dealing with current or gain which need a special case
					acfArgs.push({
						relation: 'OR',
						0: {
							key: argName+'_0_'+argName,
							compare: 'BETWEEN',
							type: 'NUMERIC',
							value: [minVal, maxVal],
						},
						1: {
							key: argName+'_1_'+argName,
							compare: 'BETWEEN',
							type: 'NUMERIC',
							value: [minVal, maxVal],
						},
					});
				}

			} else {
				staticArgs[key] = searchArg;
			}

			delete searchArgs[key];
		}
	}

	const staticArgsKeys = Object.keys(staticArgs);
	staticArgs = staticArgsKeys.map((key) => {
		return {
			taxonomy: key,
			field: 'slug',
			terms: staticArgs[key],
			operator: 'IN',
		};
	});

	const generatedArgs = {
		tax_query: staticArgs,
		meta_query: acfArgs,
		...searchArgs,
	};

	// console.log('----- Middleware args generated -----', {
	// 	generatedArgs,
	// 	staticArgs,
	// 	acfArgs,
	// });

	return generatedArgs;
};

export default middleware;
